import { render, staticRenderFns } from "./CooperationPage.vue?vue&type=template&id=1f34b9a2"
import script from "./CooperationPage.vue?vue&type=script&lang=js"
export * from "./CooperationPage.vue?vue&type=script&lang=js"
import style0 from "./CooperationPage.vue?vue&type=style&index=0&id=1f34b9a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports